import "./ProductPrice.css";
import moment from "moment";
import { Link } from "react-router-dom";

export default function ProductPrice({
    product,
    selectors = [],
    selectedVariation,
}) {
    /*
          Determine current variation
      */

    let variation = selectedVariation;

    /*
          If user has not selected anything,
          use first available option
      */

    if (!variation && selectors.length > 0) {
        variation = selectors[0]?.options?.find((option) => option.inStock);
    }

    if (!variation) {
        return (
            <div className="product-price">
                <div className="out-stock">ناموجود</div>
            </div>
        );
    }

    const price = Number(variation.price || 0);

    const salePrice = Number(variation.salePrice || variation.price);

    const hasDiscount = salePrice < price;

    const discount = hasDiscount
        ? Math.round(((price - salePrice) / price) * 100)
        : 0;

    const expire = product.selectedVariation?.expire;

    //   return (
    //     <>
    //       <div className="product-price">
    //         {!selectedVariation && selectors.length > 0 && (
    //           <div className="price-label">شروع قیمت از</div>
    //         )}

    //         <div className="price-label">
    //           <p className="lbl">قیمت مصرف کننده</p>

    //           {!hasDiscount && (
    //             <div className="current-price">
    //               {formatPrice(salePrice)}
    //               <span className="currency">تومان</span>
    //             </div>
    //           )}
    //         </div>

    //         {hasDiscount && (
    //           <div className="old-price-row">
    //             <span className="discount-badge-page">%{discount} تخفیف</span>

    //             <p className="old-price-page">{formatPrice(price)}</p>
    //           </div>
    //         )}
    //         {hasDiscount && (
    //           <div className="current-price">
    //             {formatPrice(salePrice)}
    //             <span className="currency">تومان</span>
    //           </div>
    //         )}

    //         {selectedVariation?.expire && (
    //           <div className="expire-date">
    //             <strong>
    //               {selectedVariation?.expire && (
    //                 <div className="expire-page">
    //                   <p className="expire-lbl">تاریخ انقضا:</p>
    //                   <p>
    //                     {/* {formatDate(selectedVariation.expire)} */}
    //                     {moment(selectedVariation.expire).format("YYYY/MM/DD")}
    //                   </p>
    //                 </div>
    //               )}
    //             </strong>
    //           </div>
    //         )}

    //         {/* <div className="variation-info">

    //                 {
    //                     variation.inStock ? (
    //                         <div className="stock success">
    //                             موجودی:
    //                             <strong>
    //                                 {variation.quantity}
    //                             </strong>
    //                         </div>
    //                     )
    //                         :
    //                         (
    //                             <div className="stock danger">
    //                                 ناموجود
    //                             </div>
    //                         )

    //                 }

    //             </div> */}
    //       </div>
    //     </>
    //   );


    return (
        // <div className="product-price">

        //     {!selectedVariation && selectors.length > 0 && (
        //         <div className="price-start-label">
        //             شروع قیمت از
        //         </div>
        //     )}

        //     <div className="price-label">
        //         <p className="lbl">
        //             قیمت مصرف کننده
        //         </p>
        //     </div>

        //     {hasDiscount ? (
        //         <div className="old-price-row">
        //             <p className="old-price-page">
        //                 {formatPrice(price)}
        //             </p>

        //             <span className="discount-badge-page">
        //                 %{discount} تخفیف
        //             </span>
        //         </div>
        //     ) : ''}

        //     <div className="current-price">
        //         {formatPrice(salePrice)}
        //         <span className="currency">
        //             تومان
        //         </span>
        //     </div>

        //     {selectedVariation?.expire && (
        //         <div className="expire-date">
        //             <strong>
        //                 <div className="expire-page">
        //                     <p className="expire-lbl">
        //                         تاریخ انقضا:
        //                     </p>

        //                     <p>
        //                         {moment(
        //                             selectedVariation.expire
        //                         ).format("YYYY/MM/DD")}
        //                     </p>
        //                 </div>
        //             </strong>
        //         </div>
        //     )}

        // </div>

        <div className="product-price">

            {!selectedVariation && selectors.length > 0 && (
                <div className="price-start-label">
                    شروع قیمت از
                </div>
            )}

            <div className="price-label">
                <p className="lbl">
                    قیمت مصرف کننده
                </p>
            </div>

            {hasDiscount && (
                <div className="old-price-row">
                    <p className="old-price-page">
                        {formatPrice(price)}
                    </p>

                    <span className="discount-badge-page">
                        %{discount} تخفیف
                    </span>
                </div>
            )}

            <div className="current-price">
                {formatPrice(salePrice)}
                <span className="currency">
                    تومان
                </span>
            </div>

            {selectedVariation?.expire && (
                <div className="expire-date">
                    <strong>
                        <div className="expire-page">
                            <p className="expire-lbl">
                                تاریخ انقضا:
                            </p>

                            <p>
                                {moment(
                                    selectedVariation.expire
                                ).format("YYYY/MM/DD")}
                            </p>
                        </div>
                    </strong>
                </div>
            )}

        </div>
    );
}

function formatPrice(value) {
    return Number(value).toLocaleString("fa-IR");
}

function formatDate(date) {
    if (!date) return "";

    return new Date(date).toLocaleDateString("fa-IR");
}
